import React, { forwardRef } from 'react';
import type { ForwardedRef } from 'react';

import { SideMenu } from '@vlabs/uikit';
import type { MenuItemProps } from '@vlabs/uikit/components/side-menu/menu-item/MenuItem';

import type { RequiredAnchorProps } from '@vlabs/monokit/shared/ui/popovers';

export type SideMenuFilterItemProps = MenuItemProps
  & RequiredAnchorProps
  & {
    value: string;
    testId?: string;
    badge?: React.JSX.Element | undefined;
  };

function SideMenuFilterItem(
  {
    value,
    testId = undefined,
    badge = undefined,
    ...props
  }: SideMenuFilterItemProps,
  ref: ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  return (
    // Див с рефом — анкор поповера; MenuItem не forwardRef и не пробрасывает реф.
    // Статический класс для скоупа стилей (паддинги) из конкретных меню.
    // https://jira.visionlabs.ru/browse/GUI-3063
    <div
      className="SideMenuFilterItem"
      ref={ref}
    >
      <SideMenu.MenuItem
        {...props}
        data-testid={`MenuItem.${testId}`}
        rightIcon={badge}
        value={value}
      />
    </div>
  );
}

const SideMenuFilterItemWithRef = forwardRef(SideMenuFilterItem);
export { SideMenuFilterItemWithRef as SideMenuFilterItem };
